import { CellChange, ChangeSource } from 'handsontable/common';
import _, { slice } from 'lodash';
import { ColumnData, SourceData, TemplateValidators } from 'pages/ListManagement/types';
import { EXCEL_FILE_TYPES } from 'shared/const';
import { read, utils } from 'xlsx';

export const changeListData = (data: SourceData, change: CellChange[] | null, source: ChangeSource) => {
    if (source === 'loadData') {
        return null;
    }

    if (change) {
        const newData = [...data];
        const x: number = change[0][0];
        const y: number = change[0][1] as number;

        newData[x][y] = change[0][3] as string;
        return newData;
    }

    return null;
};

export const isArrayNumbers = (sourceData: any[]) => {
    return sourceData.map((data) => _.isFinite(Number(data))).reduce((pv, cur) => pv && cur);
};

export const isArrayInterval = (sourceData: any[], min: number, max: number) => {
    return sourceData.map((data) => data >= min && data <= max).reduce((pv, cur) => pv && cur);
};

export const createColumns = (sourceData: SourceData) => {
    const columns: SourceData = [];

    sourceData.forEach((row) => {
        row.forEach((rowData, rowIndex) => {
            if (columns[rowIndex]) columns[rowIndex].push(rowData);
            else columns.push([rowData]);
        });
    });

    return columns;
};

export const checkContentHasEmptyString = (sourceData: SourceData) => {
    return sourceData.map((row) => !row.includes('') && !row.includes(null)).reduce((pv, cur) => pv && cur, false);
};

export const checkContentHasEmptyStringColumn = (sourceData: ColumnData) => {
    return !sourceData.map((row) => row === '' || row === null).reduce((pv, cur) => pv || cur, false);
};

export const checkContentIsNum = (sourceData: any[]) => {
    return isArrayNumbers(sourceData);
};

export const checkInterval = (sourceData: any[]) => {
    return isArrayInterval(sourceData, 0, 100);
};

export const checkEan = (ean: number) => {
    const validationRegex = /^[a-zA-Z0-9]{1,14}$/;
    return !(validationRegex.exec(ean.toString()) === null);
};

export const checkColumnData = (sourceData: SourceData, selectedData: string[], columnIndex: number) => {
    if (sourceData.length > columnIndex) {
        return sourceData
            .map((cell) => {
                if (cell) return selectedData.includes(cell[columnIndex] as string);
                return false;
            })
            .reduce((pv, cur) => pv && cur);
    }

    return false;
};

export const executeValidators = (templateValidators: TemplateValidators, sourceData: SourceData) => {
    return createColumns(sourceData)
        .map((column, indexColumn) =>
            templateValidators[indexColumn].map((validator) => validator(column)).reduce((pv, cur) => pv && cur, true),
        )
        .reduce((pv, cur) => pv && cur, true);
};

export const getDataFromFile = async (file: File | null) => {
    if (file && EXCEL_FILE_TYPES.includes(file.type)) {
        const dataFile = await file?.arrayBuffer();
        const wb = read(dataFile);
        const ws = wb.Sheets[wb.SheetNames[0]];
        const rows = utils.sheet_to_json(ws, { header: 1, defval: '' });
        return slice(rows, 1, rows.length) as SourceData;
    }
    return [];
};

export const requireTitle = (title: string) => {
    return `${title} *`;
};

export const listAllowedEmpty = (list: string[]) => {
    return ['-', ...list];
};

export const listWithAll = (list: string[]) => ['ALL', ...list];

export const objListWithAll = (list: { id: number; name: string }[], customName?: string) => [
    {
        id: 0,
        name: customName ? customName : 'ALL',
    },
    ...list,
];
